var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 6.3335H8.33333M8.33333 6.3335C8.33333 7.71421 9.45262 8.8335 10.8333 8.8335H11.6667C13.0474 8.8335 14.1667 7.71421 14.1667 6.3335C14.1667 4.95278 13.0474 3.8335 11.6667 3.8335H10.8333C9.45262 3.8335 8.33333 4.95278 8.33333 6.3335ZM13.3333 14.6668H17.5M16.6667 6.3335H17.5M2.5 14.6668H5M5 14.6668C5 16.0475 6.11929 17.1668 7.5 17.1668H8.33333C9.71404 17.1668 10.8333 16.0475 10.8333 14.6668C10.8333 13.2861 9.71404 12.1668 8.33333 12.1668H7.5C6.11929 12.1668 5 13.2861 5 14.6668Z",
    stroke: "#737373",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/Filter.fca346073dc2113abadf7a714ea8bf6a.svg";
export { ForwardRef as ReactComponent };